<script setup>
import axios from "axios";
import LIcon from "@/components/shared/LIcon.vue";

const props = defineProps({
  data: Object,
});

const downloadScreenshot = (data) => {
  axios.get(data.downloadable_file, { responseType: 'blob' })
    .then(response => {
      var str = data.downloadable_file;
      var n = str.lastIndexOf('/');
      var label = str.substring(n + 1);
      const blob = new Blob([response.data], { type: 'application/jpg' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = `${data.device_name}_screenshot_${label}`;
      link.click();
      URL.revokeObjectURL(link.href);
    }).catch(console.error);
};
</script>

<template>
  <div class="actions-cell">
    <button v-if="props.data.downloadable_file" @click="downloadScreenshot(props.data)" type="button" class="icon-button" title="Download">
      <LIcon name="download" />
    </button>
  </div>
</template>
